/**
 * FoxKit Quantity Breaks Badge Repositioner
 * Version: 1.3.1
 * Platform: Shopify (FoxKit Sales Boost)
 */
(function() {
    // Initialize required styles for transition handling
    const styles = document.createElement('style');
    styles.textContent = `
        .f-quantity-breaks__popular-badge {
            opacity: 0;
            transition: opacity 0.2s ease-out;
        }
        .f-quantity-breaks__popular-badge.is-positioned {
            opacity: 1;
        }
    `;
    document.head.appendChild(styles);

    const SELECTORS = {
        container: 'foxkit-quantity-breaks',
        highlightedChoice: '.f-quantity-breaks__choice--highlighted',
        popularBadge: '.f-quantity-breaks__popular-badge',
        choiceInner: '.f-quantity-breaks__choice-inner',
        choiceInfo: '.f-quantity-breaks__choice-info'
    };

    function movePopularBadge() {
        const components = document.querySelectorAll(SELECTORS.container);
        
        components.forEach(quantityBreaksComponent => {
            const targetChoice = quantityBreaksComponent.querySelector(SELECTORS.highlightedChoice);
            if (!targetChoice) return;

            const popularBadge = targetChoice.querySelector(SELECTORS.popularBadge);
            if (!popularBadge) return;

            const label = targetChoice.querySelector(SELECTORS.choiceInner);
            const firstElement = label?.querySelector(SELECTORS.choiceInfo);
            if (!label || !firstElement) return;

            if (!label.querySelector(':scope > ' + SELECTORS.popularBadge)) {
                requestAnimationFrame(() => {
                    label.insertBefore(popularBadge, firstElement);
                    // Add positioned class after DOM update
                    setTimeout(() => popularBadge.classList.add('is-positioned'), 50);
                });
            }
        });
    }

    function initializeObserver() {
        const observer = new MutationObserver(() => {
            requestAnimationFrame(movePopularBadge);
        });

        const target = document.querySelector(SELECTORS.container)?.parentElement || document.body;
        observer.observe(target, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        movePopularBadge();
    }

    // Initialize with immediate execution
    if (document.querySelector(SELECTORS.container)) {
        requestAnimationFrame(initializeObserver);
    } else {
        const observer = new MutationObserver((mutations, obs) => {
            if (document.querySelector(SELECTORS.container)) {
                obs.disconnect();
                requestAnimationFrame(initializeObserver);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();
